<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div
    class="fixed z-50 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >
      <div
        class="inline-block align-middle bg-white rounded-xl text-left overflow-hidden shadow-2xl transform transition-all w-full sm:w-11/12 md:w-2/3 lg:w-1/2 my-8"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="flex flex-col bg-white rounded p-2 sm:p-6">
            <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-100">
              <h3
                class="text-lg leading-6 font-semibold text-gray-900"
                id="modal-title"
              >
                Admin Credit Retailer Wallet
              </h3>
              <button type="button" class="text-gray-400 hover:text-gray-600 transition-colors" @click="cancelRechargeTransaction" aria-label="Close">
                <i class="fas fa-times text-lg"></i>
              </button>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Retailer Business Name</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <p class="text-sm text-gray-900">{{ business_name }}</p>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Retailer Mobile</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <p class="text-sm text-gray-900">{{ mobile }}</p>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Country</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <p class="text-sm text-gray-900">{{ country }}</p>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Unique ID</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <p class="text-sm text-gray-900">{{ user_id }}</p>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Enter Recharge Amount</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="number"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="amount"
                  placeholder="0"
                  min="0"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Bank Payment Reference</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="text"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="payment_ref"
                  placeholder="Optional Payment Reference"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Currency</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0 text-sm text-gray-900">
                {{ currency }}
              </div>
            </div>

            <!--            <div class="flex  items-center justify-between mt-4 ">-->
            <!--              <p class="inline w-1/3">Phone</p>-->
            <!--              <div class="flex space-x-2 w-2/3 justify-between">-->
            <!--                <input  type="text" class="border-2 rounded p-3 w-full" v-model.trim="form.phone" placeholder="e.g 234XXXXXXXXXX"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <div
              class="flex flex-col sm:flex-row items-center justify-end gap-3 mt-8 pt-4 border-t border-gray-100"
            >
              <button
                type="button"
                v-if="disable_button"
                class="w-full sm:w-auto inline-flex justify-center rounded-lg px-5 py-2.5 bg-express text-sm font-medium text-white hover:bg-expressbutton transition-colors"
                @click="completeRechargeTransaction"
              >
                Top Up Retailer
              </button>
              <button
                type="button"
                class="w-full sm:w-auto inline-flex justify-center rounded-lg border border-gray-200 px-5 py-2.5 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                @click="cancelRechargeTransaction"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "add_retailer_model",
  props: ["country", "user_id", "business_name", "mobile"],
  emits: ["completeRechargeTransaction", "cancelRechargeTransaction"],
  created() {
    if (this.country === "Nigeria") {
      this.currency = "NGN";
    } else if (this.country === "CIV") {
      this.currency = "XOF";
    } else {
      this.currency = "GHS";
    }
  },
  data() {
    return {
      amount: null,
      recharge_type: "administrator_top_up",
      currency: null,
      disable_button: false,
      payment_ref: null,
    };
  },
  watch: {
    amount: function (newval) {
      if (this.country === "Nigeria") {
        this.currency = "NGN";
      } else if (this.country === "CIV") {
        this.currency = "XOF";
      } else {
        this.currency = "GHS";
      }
      if (newval <= 0) {
        this.amount = null;
        this.disable_button = false;
      } else {
        this.disable_button = true;
      }
    },
  },

  methods: {
    completeRechargeTransaction() {
      console.log("completeRechargeTransaction triggered");
      this.$store.dispatch("admins/action_admin_update_retailer_balance", {
        retailer_id: this.user_id,
        amount: this.amount,
        currency: this.currency,
        payment_ref: this.payment_ref,
        toast: this.$toast,
        router: this.$router,
      });
      this.$emit("completeRechargeTransaction");
      // action_admin_update_retailer_balance
    },
    cancelRechargeTransaction: function (e) {
      console.log(e);
      this.$emit("cancelRechargeTransaction");
    },
  },
};
</script>

<style scoped></style>
